import FF4JClient, { IProjectDetails } from '@ninjacart/nc-nk-ff4j';

const ff4jProjectDetails: IProjectDetails = {
  projectRealmId: '1', //bring from env
  projectUserId: '1', //bring from env
  projectName: 'Ninja-Kisan-Prod', //bring from env
  projectToolId: 'eb0870b5-ff9e-48bd-9f18-f95d99d2d53a', //bring from env
};

export const ff4jClient = new FF4JClient(
  process.env.FF4J_BASE_URL || 'https://apiv2.ninjacart.in',
  process.env.FF4J_API_KEY || 'eb0870b5-ff9e-48bd-9f18-f95d99d2d53a',
  ff4jProjectDetails,
  60000
);
